var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewTaskManagerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.945a2 2 0 012-2h32a2 2 0 110 4H4a2 2 0 01-2-2zM2 16.285a2 2 0 012-2h32a2 2 0 110 4H4a2 2 0 01-2-2zM4 23.605a2 2 0 000 4h12a2 2 0 100-4H4zM2 34.945a2 2 0 012-2h12a2 2 0 110 4H4a2 2 0 01-2-2zM37.414 27.36a2 2 0 10-2.828-2.83L27 32.118l-3.586-3.586a2 2 0 10-2.828 2.828l5 5a2 2 0 002.828 0l9-9z",
    fill: "#fff"
  })));
}

export default SvgNewTaskManagerIcon;